enum GeneEnum {
  G = 'G',
  H = 'H',
  Y = 'Y',
  W = 'W',
  X = 'X'
}

export default GeneEnum;
